<template>
  <div>
    <div class="no-margins goBackAtTop">
      <v-btn text @click="$emit('showBase')">
        <v-icon>$sl-arrow-left</v-icon>{{ $route.params.type=='tradecertificate-card' ? $t('order-card.order.title2') : $t('order-card.order.title') }}
      </v-btn>
    </div>
    <div class="mt-2">
      <h1>{{ detail.title }}</h1>
    </div>

    <!-- <h2 class="mt-n1">{{ detail.subtitle }}</h2> -->
    <!-- <div v-if="!contactByn">
      <v-textarea :rules="[rules.required]" outlined v-model="cardReason"></v-textarea>
      <ActionButton actionIcon="$sl-equipment-truck" @click="contactByn = true" :isDisabled="cardReason && cardReason.length == 0">{{
        $route.params.type=='tradecertificate-card' ? $t('order-card.order.title2') : $t('labels.card-machine-orders')
      }}</ActionButton>
    </div> -->
    <div>
      <MessageBox class="mb-7" type="info">
        <h6>{{ detail.message.title }}</h6>
        <p>
          {{ detail.message.text1 }}
          <a :href="links.main.bynContact" target="_blank">{{ detail.message.link }}</a>
          {{ detail.message.text2 }}
        </p>
      </MessageBox>
    </div>
  </div>
</template>

<script>
import MessageBox from '@/components/Common/MessageBox.vue'
import GoBackAtTop from '@/components/Common/GoBackAtTop'
import ActionButton from '@/components/Common/ActionButton'
import {RulesMixin} from '@/components/mixins'
export default {
  mixins: [RulesMixin],
  components: {
    MessageBox,
    ActionButton,
    GoBackAtTop
  },
  props: {
    detail: {
      // `Object`
      type: Object,
      // The default value is: `function returning a Object`
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      links: require('../../lib/external-links.json'),
      cardReason: '',
      contactByn: false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>